import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import { inserirOuAtualizar, criarFormulasIptuDs } from "../../DataSources";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  titulo: "",
  formula: "",
  descricao: "",
};

export default class FormulasForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...(_cadastroCorrente || template) };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.formulaIptuDs = criarFormulasIptuDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
  }

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.formulaIptuDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (!data) {
              notify("Registro não encontrado.", "error");
              this.props.history.push("/contasbancarias");
            }
            this.setState(data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      }
    } else {
      this.setState({ ...template });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem caption="FÓRMULA DE IPTU" colSpan={2} colCount={2}>
              <SimpleItem dataField={"titulo"}>
                <Label text="Título" />
              </SimpleItem>
              <SimpleItem dataField={"formula"}>
                <Label text="Fórmula" />
              </SimpleItem>
              <SimpleItem
                dataField={"descricao"}
                editorType={"dxTextArea"}
                colSpan={2}
              >
                <Label text="Descrição" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button text="Cancelar" onClick={this.cancel} width={120} />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    inserirOuAtualizar(this.formulaIptuDs, entidade)
      .then(
        function () {
          _cadastroCorrente = undefined;
          _cancelando = true;
          notify("Fórmula cadastrada com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
